import React from "react";

const SearchIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1_15374)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.4265 7.9651C13.4265 10.9835 10.9796 13.4304 7.96117 13.4304C4.94278 13.4304 2.49589 10.9835 2.49589 7.9651C2.49589 4.9467 4.94278 2.4998 7.96117 2.4998C10.9796 2.4998 13.4265 4.9467 13.4265 7.9651ZM12.6402 14.4117C11.3265 15.3668 9.70964 15.9302 7.96117 15.9302C3.56218 15.9302 -0.00390625 12.3641 -0.00390625 7.9651C-0.00390625 3.5661 3.56218 0 7.96117 0C12.3602 0 15.9263 3.5661 15.9263 7.9651C15.9263 9.71354 15.3629 11.3304 14.4078 12.6441L19.289 17.5253C19.6795 17.9158 19.6795 18.549 19.289 18.9395L18.9356 19.2929C18.5451 19.6834 17.9119 19.6834 17.5214 19.2929L12.6402 14.4117Z"
                    fill="#2275EE"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_15374">
                    <rect width="20" height="20" fill="white" transform="translate(-0.00390625)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default SearchIcon;
